export const CopyLink = {
  mounted() {
    this.el.addEventListener('click', () => this.clicked());
  },

  clicked() {
    navigator.clipboard.writeText(this.el.dataset.copy);
    this.el.classList.add('clicked');
    setTimeout(() => this.el.classList.remove('clicked'), 1);
  }
};
